<template>
  <!-- NOTE (TEMPLATE) to build a general review and use it in the project as a component -->

  <div class="animated fadeIn">
    <table class="table table-striped">
      <tbody>
        <tr
          :class="
            score[0] == 4
              ? 'bg-success'
              : score[0] == 3
              ? 'table-success'
              : score[0] == 2
              ? 'table-warning'
              : score[0] == 1
              ? 'table-danger'
              : score[0] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>ارتباط با زیست فناوری</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[0]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[1] == 4
              ? 'bg-success'
              : score[1] == 3
              ? 'table-success'
              : score[1] == 2
              ? 'table-warning'
              : score[1] == 1
              ? 'table-danger'
              : score[1] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>همراستایی با اولویت های تقسیم کار ملی زیست فناوری</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[1]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[2] == 4
              ? 'bg-success'
              : score[2] == 3
              ? 'table-success'
              : score[2] == 2
              ? 'table-warning'
              : score[2] == 1
              ? 'table-danger'
              : score[2] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>چارک مجله مورد نظر که مقاله در آن به چاپ رسیده</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[2]">
              <b-form-radio :value="0">نامشخص</b-form-radio>
              <b-form-radio :value="4">Q1</b-form-radio>
              <b-form-radio :value="3">Q2</b-form-radio>
              <b-form-radio :value="2">Q3</b-form-radio>
              <b-form-radio :value="1">Q4</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr
          :class="
            score[3] == 4
              ? 'bg-success'
              : score[3] == 3
              ? 'table-success'
              : score[3] == 2
              ? 'table-warning'
              : score[3] == 1
              ? 'table-danger'
              : score[3] == 0
              ? 'bg-danger'
              : 'table-dark'
          "
        >
          <td>کاربردی بودن مقاله</td>
          <td>
            <b-form-radio-group :disabled="disabled" v-model="score[3]">
              <b-form-radio :value="0">غیر قابل قبول</b-form-radio>
              <b-form-radio :value="1">ضعیف</b-form-radio>
              <b-form-radio :value="2">متوسط</b-form-radio>
              <b-form-radio :value="3">خوب</b-form-radio>
              <b-form-radio :value="4">عالی</b-form-radio>
            </b-form-radio-group>
          </td>
        </tr>
        <tr>
          <td>نقاط قوت و ضعف طرح از دید داور</td>
          <td>
            <b-form-textarea
              trim
              :disabled="disabled"
              v-model="refereeIdea2"
            ></b-form-textarea>
          </td>
        </tr>
        <tr>
          <td>نمره کل طرح از 100</td>
          <td>{{ totalScore }}</td>
        </tr>
        <tr>
          <td>نظر نهایی داور</td>
          <td>
            <b-form-select
              :disabled="disabled"
              :options="refereeDecisions"
              v-model="refereeDecision2"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!disabled">
      <p
        variant="danger"
        v-if="
          !(
            refereeDecision2 &&
            score.filter((x) => x).length == 4 &&
            refereeIdea2
          )
        "
      >
        لطفا به منظور ثبت داوری به تمامی سوالات چند گزینه‌ای پاسخ دهید و نظر
        نهایی خود را نیز انتخاب کنید.
      </p>
      <p></p>
      <div class="d-flex justify-content-center">
        <!-- NOTE (b-sendReview) to send review -->
        <b-button
          variant="success"
          class="mx-2"
          :disabled="
            !(
              refereeDecision2 &&
              score.filter((x) => String(x)).length == 4 &&
              refereeIdea2
            ) || isBusy
          "
          @click="
            sendReview();
            isBusy = true;
          "
          >ارسال داوری</b-button
        >
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main"; // REVIEW

export default {
  name: "Reviewing",
  props: ["disabled", "scoresData", "refereeIdea", "refereeDecision"],
  components: {},

  data() {
    return {
      isBusy: false,
      refereeDecision2: this.refereeDecision,
      refereeIdea2: this.refereeIdea,
      score: [2, 2, 2, 2],
      weight: [20, 10, 50, 20],

      refereeDecisions: [
        { value: null, text: "لطفا نظر خود را انتخاب کنید", disabled: true },
        { value: "accept", text: "مورد تایید است" },
        {
          value: "minorRevision",
          text: "با اصلاحات بدون نیاز به داوری مجدد مورد تایید است",
        },
        {
          value: "majorRevision",
          text: "نیازمند اصلاحات و داوری مجدد",
        },
        { value: "reject", text: "مورد تایید نیست" },
      ],
    };
  },

  computed: {
    totalScore() {
      // NOTE (c-totalScore) to show the proposal total score
      let totalScore = 0;
      for (let i = 0; i < 4; i++) {
        totalScore += this.score[i] * this.weight[i];
      }
      return totalScore / 4;
    },
  },
  methods: {
    sendReview() {
      // NOTE (m-sendReview) to send review
      this.$http
        .post(
          this.baseUrl + "/setad/reviewer/review/article/done",
          {
            reviewId: this.$route.params.judgeId,
            description: this.refereeIdea2,
            decision: this.refereeDecision2,
            scores: this.score,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            EventBus.$emit("refereeAdded", {});
            this.$router.replace("/referee/archive");
          } else if (res.status == 202) {
            this.toast(res.data.text, "success");
            this.toast(res.data.error, "error");
            this.$router.replace("/referee/archive");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });

      this.fileBusy = false;
    },
  },
  mounted() {
    // NOTE (MOUNTED) to show data of proposal score
    if (this.scoresData) this.score = this.scoresData;
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
